module.exports = __webpack_public_path__ + "img/sjfw.391481da.png";